import MessageComposeAdapter from '../../adapters/MessageComposeAdapter';
import onComposeClose from 'owa-addins-view/lib/utils/entryPointOperations/onComposeClose';
import { getAdapter } from '../../adapters/AdapterManager';

export default function closeApiMethod(hostItemIndex: string, controlId: string) {
    const adapter: MessageComposeAdapter = getAdapter(hostItemIndex) as MessageComposeAdapter;
    adapter.close();
    onComposeClose(hostItemIndex);
}
